// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ducklett: PokeData = {
  "id": 580,
  "name": "ducklett",
  "height": 5,
  "weight": 55,
  "base_experience": 61,
  "types": [
    PokeType.WATER,
    PokeType.FLYING
  ],
  "api_moves": [
    "wing-attack",
    "water-gun",
    "bubble-beam",
    "rain-dance",
    "feather-dance",
    "aerial-ace",
    "water-sport",
    "water-pulse",
    "roost",
    "tailwind",
    "aqua-ring",
    "air-slash",
    "brave-bird",
    "defog",
    "hurricane"
  ],
  "moves": [
    "bubble-beam",
    "rain-dance",
    "aerial-ace",
    "roost",
    "tailwind",
    "air-slash",
    "brave-bird",
    "hurricane",
    "aqua-cutter",
    "hydro-pump",
    "water-spout",
    "liquidation",
    "brine"
  ],
  "evolution_chain": {
    "id": 295,
    "item": null,
    "species": [
      {
        "name": "ducklett",
        "order": 581,
        "types": [
          PokeType.WATER,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "swanna",
        "order": 582,
        "types": [
          PokeType.WATER,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 580,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 56,
    "speed": 55,
    "ability_power": 44
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
